/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Stats_Page_SubtitleInputs */

const vi_warehouse_stats_page_subtitle = /** @type {(inputs: Warehouse_Stats_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biến động nhập/xuất/tồn của toàn bộ 5 kho trong cùng một kỳ`)
};

/**

* @param {Warehouse_Stats_Page_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_stats_page_subtitle = /** @type {((inputs?: Warehouse_Stats_Page_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Stats_Page_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_stats_page_subtitle(inputs)
});